import { render, staticRenderFns } from "./CompetitionEdit.vue?vue&type=template&id=1c2b4426&"
import script from "./CompetitionEdit.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports